import React, { useState, useEffect } from "react";
import UserLayout from "../../components/user-layout/UserLayout";

import styles from "./createJobPost.module.scss";
import authService from "../../utils/services/authService";
import AddJobOne from "../../components/add-job-post-forms/AddJobOne";
import AddJobTwo from "../../components/add-job-post-forms/AddJobTwo";
import AddJobThree from "../../components/add-job-post-forms/AddJobThree";

const CreateJobPost = () => {
  //Page states

  const [steps, setSteps] = useState({
    stepOne: true,
    stepTwo: false,
    stepThree: false,
  });

  const [jobPost, setJobPost] = useState({
    jobTitle: "",
    description: "",
    tech: [],
    requirements: {
      salary: "",
      jobType: "",
      jobCategory: "",
      experience: "",
      location: "",
      remote: "",
    },
    companyInfo: {
      companyName: "",
      companySize: "",
      companyType: "",
      companyDescription: "",
      perks: [],
    },
  });
  // stores the postId returned when a post is successfully created, to then pass when updating the same post with the rest of the data in coming forms.
  const [createdPostId, setCreatedPostId] = useState("");

  const userData = authService.getUserData();

  const onChangeHandle = (e) => {
    const value = e.target.value;
    setJobPost({ ...jobPost, [e.target.name]: value });
  };

  return (
    <UserLayout>
      <section className={styles.createJobWrapper}>
        <h2 className={styles.createJobWrapper_heading}>
          Follow the steps below to post your joblisting!
        </h2>
        {steps.stepOne && (
          <AddJobOne
            steps={steps}
            setSteps={setSteps}
            jobPost={jobPost}
            setJobPost={setJobPost}
            setCreatedPostId={setCreatedPostId}
            onChangeHandle={onChangeHandle}
          />
        )}

        {steps.stepTwo && (
          <AddJobTwo
            steps={steps}
            setSteps={setSteps}
            jobPost={jobPost}
            setJobPost={setJobPost}
            setCreatedPostId={setCreatedPostId}
            onChangeHandle={onChangeHandle}
            createdPostId={createdPostId}
          />
        )}
        {steps.stepThree && (
          <AddJobThree
            steps={steps}
            setSteps={setSteps}
            jobPost={jobPost}
            setJobPost={setJobPost}
            onChangeHandle={onChangeHandle}
            createdPostId={createdPostId}
            userData={userData}
          />
        )}
      </section>
    </UserLayout>
  );
};

export default CreateJobPost;
